/**
 * Feature setting to launch Decagon AI chatbot, all the feature behind this toggle are enabled fully when launched. It's different from the experiment setting HELP_CENTER_AI_CHATBOT_240903
 */
export const HELP_CENTER_DECAGON_CHATBOT_EVALUATION_240510 = 'HELP_CENTER_DECAGON_CHATBOT_EVALUATION_240510';
